import React from "react";
import { ExportType } from "../../../../lib-api";
import { CustomDataGridHeader } from "../../../shared/datagrid/CustomDataGridHeader";

export const ExportVinDataToolbar: React.FunctionComponent<{
  uploadVins: (
    vins: string[],
    exportType: ExportType,
    projectFolderId?: string | undefined,
    name?: string | undefined
  ) => Promise<void>;
}> = (props) => {
  return (
    <CustomDataGridHeader
      headerProps={{
        displayHeadline: "Vin lookup",
        filters: [
          {
            type: "submitmultiplewithprojects",
            loadingText: "Adding Registrationnumbers..",
            name: "Upload multiple Registrationnumbers",
            placeholder: "Name of data",
            onSubmitVehicleId: (ids, projectId, name) => {
              props.uploadVins(
                ids,
                ExportType.VinData,
                projectId == "-1" ? undefined : projectId,
                name
              );
            },
            position: "right",
          },
        ],
        isTab: true,
      }}
    ></CustomDataGridHeader>
  );
};
